<script>
export default {
    inheritAttrs: false,
}
</script>

<script setup>
import { useAttrs } from 'vue';
import { Link, usePage } from '@inertiajs/vue3';
import { Bars3Icon } from '@heroicons/vue/24/outline';
import { AvatarDropdown, PersoneoLogo, ShinyButton } from '@/Components';
import { ChartBarIcon, NewspaperIcon, SparklesIcon, UserIcon } from '@heroicons/vue/24/outline';
import { twMerge } from 'tailwind-merge';
import { usePermissions } from '@/composables';

const emit = defineEmits(['update:isOpen']);

const attrs = useAttrs()

const { can } = usePermissions();

const menuItems = [
    { name: 'Dashboard', url: route('dashboard'), icon: NewspaperIcon },
    { name: 'Explore', url: route('explore'), icon: SparklesIcon },
    { name: 'Analytics', url: route('analytics'), icon: ChartBarIcon },
    { name: 'Profile', url: route('publicProfile.me'), icon: UserIcon },
];

const page = usePage();

function isActiveMenuItem(menuItem) {
    if (menuItem.url === '#') {
        return false;
    }

    const url = new URL(menuItem.url);
    return page.url.startsWith(url.pathname);
}
</script>

<template>
    <aside 
        v-bind="attrs"
        :class="twMerge('flex flex-col overflow-y-scroll bg-slate-100 p-4 relative z-10 shadow-lg', attrs.class)"
    >
        <div class="flex items-center gap-x-3 mb-10">
            <Bars3Icon
                class="h-8 cursor-pointer transition-transform ease-out duration-75 shrink-0 grow-0"
                @click="emit('update:isOpen', false)" 
            />
            <Link :href="route('dashboard')">
                <PersoneoLogo class="grow-0 shrink-0" />
            </Link>
        </div>
        <div class="grow overflow-y-auto -mr-4 pr-4">
            <Link v-if="can('access builder')" :href="route('simulations.create')">
                <ShinyButton class="mx-auto block">Create roleplay</ShinyButton>
            </Link>
            <div class="mt-12 space-y-2">
                <Link 
                    v-for="menuItem in menuItems" 
                    :key="menuItem.name" 
                    :href="menuItem.url" 
                    class="block"
                >
                    <div class="flex items-center gap-x-2 py-3 px-4 transition-colors ease-in duration-75 hover:bg-primary/10 rounded-full cursor-pointer"
                        :class="{ 'text-primary font-semibold': isActiveMenuItem(menuItem) }"
                    >
                        <Component :is="menuItem.icon" class="w-7 aspect-square stroke-current" />
                        <div>{{ menuItem.name }}</div>
                    </div>
                </Link>
            </div>
        </div>
        <div class="flex flex-col justify-end mt-6">
            <slot name="footer">
                <AvatarDropdown placement="top" class="-mx-3" />
            </slot>
        </div>
    </aside>
</template>
